module.exports = __webpack_public_path__ + "img/circle_icon_1.b0544a5.svg";